
@if (this.ReportType === "DEV") {
  <iframe title="CDP MERSY Direct-Report"
    style="height: 85vh; display: block; width: -webkit-fill-available"
    src="https://app.powerbi.com/reportEmbed?reportId=2bd5cdb1-bf13-49a9-abce-27f8af9cc36a&autoAuth=true&ctid=84d9a216-e285-4aac-b163-0dfd0c074546&actionBarEnabled=true&reportCopilotInEmbed=true"
    frameborder="0"
    allowFullScreen="true">
  </iframe>
}


@if (this.ReportType === "PROD") {
  <iframe title="CDP MERSY Direct-Report"
    style="height: 85vh; display: block; width: -webkit-fill-available"
    src="https://app.powerbi.com/reportEmbed?reportId=15c350ee-88f8-4ce0-a490-34360cb9b4ad&autoAuth=true&ctid=84d9a216-e285-4aac-b163-0dfd0c074546"
    frameborder="0"
    allowFullScreen="true">
  </iframe>
}


